var cilLockUnlocked = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M384,200V144A128,128,0,0,0,166.418,52.57l22.4,22.855A96,96,0,0,1,352,144v56H88V328c0,92.636,75.364,168,168,168s168-75.364,168-168V200Zm8,128c0,74.99-61.009,136-136,136s-136-61.01-136-136V232H392Z' class='ci-primary'/>"];

export { cilLockUnlocked };

